<template>
  <div class="button-download-pdf">
    <div class="login text-center">

      <p class="termLead">株式会社Yagishの<a href="/terms" target="_blank">利用規約</a>、<a
          href="https://www.yagish.jp/privacy_policy/" target="_blank">プライバシーポリシー</a>に同意の上、ログイン（会員登録）してください。</p>
      <p>
        <el-checkbox v-model="isAgree">同意する</el-checkbox>
      </p>

      <div class="login_formBlock social_login">
        <p class="loginCategory">ソーシャルログイン</p>
        <div class="social_loginlist">
          <el-button id="google-login" class="social_loginitem google-login" @click="signInGoogle();">
            <p class="social_logintxt">Googleアカウントでログイン</p>
          </el-button>
          <button v-if="$site.appFlag != 'b'" id="line-login" class="social_loginitem line-login"
            @click="signInLine();">
            <p class="social_logintxt">LINEでログイン</p>
          </button>
          <button id="apple-login" class="social_loginitem apple-login" @click="signInApple();">
            <p class="social_logintxt">appleIDでログイン</p>
          </button>
        </div>
      </div>

      <div class="login_formBlock account_login">
        <p class="loginCategory">またはアカウント情報を入力</p>
        <div class="account_loginForm">
          <el-input v-model="mailLogin.email" type="email" autocomplete name="mail-link-input" :class="'formmb'"
            placeholder="メールアドレスを入力してください" :disabled="loginEmailSending"></el-input>
          <el-input v-model="mailLogin.passwd" type="password" autocomplete name="mail-link-input" :class="'formmb'"
            placeholder="パスワードを入力してください" :disabled="loginEmailSending"></el-input>
        </div>
        <el-button type="primary" id="account_login" class="account_loginbtn" :plain="isPlainButton"
          @click="loginIdPw(mailLogin.email, mailLogin.passwd)" v-loading="loginEmailSending">ログインする</el-button>
        <a href="/repasswd" class="pw-change">パスワードを忘れた方はこちら</a>
      </div>

      <div class="login_formBlock maillink_login" v-if="$site.appFlag != 'b'">
        <p class="loginCategory">またはリンククリックログイン</p>
        <p class="loginLead">メールに届いたリンクをクリックするだけでかんたんにログインできます。</p>
        <div class="account_loginForm">
          <el-form ref="mailLoginForm" :model='mailLogin' :rules='mailLoginRules' @submit.native.prevent>
            <el-form-item :required='true' prop='email'>
              <el-input v-model="mailLogin.email" type="email" autocomplete name="mail-link-input" :class="'formmb'"
                placeholder="yagish@example.com" :disabled="loginEmailSending"></el-input>
            </el-form-item>
            <el-button type="primary" id="maillink_login" class="button-block" :plain="isPlainButton"
              @click="mailSubmit" v-loading="loginEmailSending">メールでリンクを送る</el-button>
          </el-form>
        </div>
      </div>

    </div>
  </div>
</template>
<style scoped>
.button-download-wrapper .button-download-pdf {
  background: #eef5e8;
  border-radius: 10px;
  padding: 25px;
}

.button-download-wrapper .login {
  background: #ffffff;
  border-radius: 10px;
  padding: 25px;
  max-width: 480px;
  margin: 0 auto;
}

.button-download-wrapper .el-checkbox {
  font-size: 14px;
}

.button-download-wrapper .el-checkbox__label {
  font-size: 14px;
  padding-left: 5px;
}

.button-download-wrapper .login_formBlock {
  margin-top: 30px;
  overflow: hidden;
}

.button-download-wrapper .loginCategory {
  margin-bottom: 10px;
  position: relative;
  display: inline-block;
  padding: 0 30px;
}

.button-download-wrapper .loginCategory::before,
.button-download-wrapper .loginCategory::after {
  content: '';
  position: absolute;
  top: 50%;
  display: inline-block;
  width: 45px;
  height: 1px;
  background-color: #dfdfdf;
}

.button-download-wrapper .loginCategory::before {
  left: -30px;
}

.button-download-wrapper .loginCategory::after {
  right: -30px;
}

.button-download-wrapper .social_loginitem {
  position: relative;
  background: none;
  padding: 0;
  margin-bottom: 10px;
  width: 100%;
  text-align: center;
  font-weight: bold;
  height: 50px;
  border: 1px solid #dfdfdf;
  border-radius: 5px;
}

.button-download-wrapper .social_loginitem:last-child {
  margin-bottom: 0;
}

.button-download-wrapper .social_loginitem::before {
  position: absolute;
  content: "";
  background-image: url(/static/renew_img/icon/google.png);
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  width: 30px;
  height: 30px;
  top: 10px;
  left: 20px;
  margin: auto;
}

.button-download-wrapper .line-login::before {
  background-image: url(/static/renew2_img/line_icon.jpeg);
  width: 26px;
  height: 26px;
  left: 23px;
}

.button-download-wrapper .apple-login::before {
  background-image: url(/static/renew_img/icon/appleinc.png);
  width: 26px;
  height: 30px;
  left: 24px;
  top: 8px;
}

.button-download-wrapper .account_loginbtn {
  width: 100%;
  height: 50px;
  font-weight: bold;
}

.button-download-wrapper .loginLead {
  font-size: 12px;
  margin-bottom: 10px;
}

.button-download-wrapper .el-form-item {
  margin-bottom: 0;
}

.button-download-wrapper .button-block {
  height: 50px;
  font-weight: bold;
}

@media screen and (max-width: 640px) {
  .button-download-wrapper .button-download-pdf {
    padding: 0;
    background: none;
  }

  .button-download-wrapper .login {
    padding: 0;
  }

  .button-download-wrapper .termLead {
    text-align: left;
  }

  .button-download-wrapper .social_loginitem::before {
    left: 10px;
  }

  .button-download-wrapper .line-login::before {
    left: 13px;
  }

  .button-download-wrapper .apple-login::before {
    left: 14px;
  }

  .button-download-wrapper .loginLead {
    text-align: left;
  }
}
</style>
<style lang="scss" scoped>
.button-download-wrapper {
  .formmb {
    ::v-deep .el-input__inner {
      height: 50px;
      margin-bottom: 10px;
    }
  }
}
</style>
<script>
export default {
  props: {
    isPlainButton: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      loginEmailSending: false,
      isAgree: true,
      mailLogin: {
        email: ''
      },
      mailLoginRules: {
        email: [
          {
            required: true,
            message: 'メールアドレスをいれてね',
            trigger: 'blur'
          },
          {
            required: true,
            type: 'email',
            message: 'メールアドレスをいれてね',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  computed: {
    getMode: function () {
      return process.env.VUE_APP_MODE
    }
  },
  methods: {
    signInGoogle: function () {
      if (!this.isAgree) {
        this.$message({
          message: '利用規約と個人情報の扱いに同意してください。',
          type: 'error'
        })
        return
      }
      this.$firebase.signInGoogle()
    },
    signInLine: function () {
      if (!this.isAgree) {
        this.$message({
          message: '利用規約と個人情報の扱いに同意してください。',
          type: 'error'
        })
        return
      }
      this.$firebase.signInLine()
    },
    signInApple: function () {
      if (!this.isAgree) {
        this.$message({
          message: '利用規約と個人情報の扱いに同意してください。',
          type: 'error'
        })
        return
      }
      this.$firebase.signInApple()
    },
    resetloginEmail: function () {
      this.mailLogin.email = ''
      this.loginEmailSending = false
      this.$refs.mailLoginForm.resetFields()
    },
    mailSubmit: function () {
      if (!this.isAgree) {
        this.$message({
          message: '利用規約と個人情報の扱いに同意してください。',
          type: 'error'
        })
        return
      }
      const app = this
      this.$refs.mailLoginForm.validate(async valid => {
        if (!valid) {
          return
        }
        app.$firebase.signInEmail(app.mailLogin.email)
        app.loginEmailSending = true
      })
    },
    loginIdPw: function (id, pw) {
      if (!this.isAgree) {
        this.$message({
          message: '利用規約と個人情報の扱いに同意してください。',
          type: 'error'
        })
        return
      }
      this.fullscreenLoading = true
      this.$firebase.signInEmailPasswd(id, pw)
    }
  },
  mounted: function () {
    this.$eventHub.$on('sing-in-mail-send', this.resetloginEmail)
    this.$eventHub.$on('sing-in-mail-failed', this.resetloginEmail)
  },
  destroyed: function () {
    this.$eventHub.$off('sing-in-mail-send', this.resetloginEmail)
    this.$eventHub.$off('sing-in-mail-failed', this.resetloginEmail)
  }
}
</script>
